var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"confirmation",style:(_vm.$parent.getStyle)},[_vm._v(" "+_vm._s(_vm.$parent.getSubmitSuccessMessage)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }